import { useState, } from "react";

export default function ServiceCleaning(props) {
  const [chosenCleaning, setChooseCleaning] = useState(props.service.extraData[0] ?? props.service.type_id);

  const setDescription = (description) => {
    if (description == '') {
      content = null;
    } else {
      content = <div>
        <br />
        <h4 className='ui header'>Beschreibung</h4>
        {description}
      </div>
    }
  }

  const chooseCleaning = (serviceId) => {
    props.service.extraData[0] = serviceId;
    setChooseCleaning(serviceId);
    //update service caption
    props.machineType.cleaning.map(function (obj, i) {
      if(obj.id==serviceId){
        props.service.name=obj.name;
      }
    });
  }

  
  let content;
  Object.entries(props.machineType.cleaning).forEach(([key, service]) => {
    if (service.id == chosenCleaning) {
      setDescription(service.description)
    }
  });
  if(props.service.originalName==undefined)props.service.originalName=props.service.name;

  return (
    <div>
      Für den Automaten wird die Reinigung "{props.service.originalName}" vorgeschlagen.<br />
      <br />
      Wählen Sie aus, welche Reinigung duchgeführt wurde:
      <div className="ui form">
        <div className="field">
          <select value={chosenCleaning} defaultValue={props.service.extraData[0] ?? props.service.type_id} multiple={false} onChange={e => { chooseCleaning(e.target.value) }}>
            {
              props.machineType.cleaning.map(function (obj, i) {
                return <option value={obj.id} key={obj.id}>{obj.name}</option>;
              })
            }
          </select>
        </div>
      </div>
      {content}
    </div>
  );
}